"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AnimatedFlex;
/* eslint-disable consistent-return */
var react_1 = __importStar(require("react"));
// @ts-ignore
var index_1 = __importDefault(require("./index"));
var interval;
function AnimatedFlex(_a) {
    var children = _a.children, _b = _a.directionIn, directionIn = _b === void 0 ? 'left' : _b, _c = _a.distance, distance = _c === void 0 ? '80px' : _c, _d = _a.delay, delay = _d === void 0 ? 10 : _d, _e = _a.transition, transition = _e === void 0 ? '0.3s ease-out all' : _e, isVisible = _a.isVisible, _f = _a.style, style = _f === void 0 ? {} : _f, rest = __rest(_a, ["children", "directionIn", "distance", "delay", "transition", "isVisible", "style"]);
    var isHidden = isVisible === false;
    var _g = (0, react_1.useState)(false), mounted = _g[0], setMounted = _g[1];
    (0, react_1.useEffect)(function () {
        if (isHidden) {
            setMounted(false);
            return;
        }
        if (!delay) {
            setMounted(true);
            return;
        }
        interval = setTimeout(function () { return setMounted(true); }, delay);
        return function () {
            if (interval) {
                clearTimeout(interval);
            }
        };
    }, [isHidden, delay]);
    var ANIMATIONS = {
        left: {
            transition: transition,
            opacity: mounted ? 1 : 0,
            transform: "translateX(".concat(mounted ? 0 : distance, ")"),
        },
        right: {
            transition: transition,
            opacity: mounted ? 1 : 0,
            transform: "translateX(".concat(mounted ? 0 : "-".concat(distance), ")"),
        },
        up: {
            transition: transition,
            opacity: mounted ? 1 : 0,
            transform: "translateY(".concat(mounted ? 0 : distance, ")"),
        },
        down: {
            transition: transition,
            opacity: mounted ? 1 : 0,
            transform: "translateY(".concat(mounted ? 0 : "-".concat(distance), ")"),
        },
    };
    var selectedAnimation = ANIMATIONS[directionIn];
    return (react_1.default.createElement(index_1.default, __assign({ style: __assign(__assign({}, selectedAnimation), style) }, rest), children));
}
